import React from 'react';
import styled, { withTheme } from 'styled-components'
import { Wrapper } from '../../containers/Wrapper'
import CtaBg from '../../../../assets/img/bg/external-cta.jpg';
import ButtonBg from '../../../../assets/img/Stock_images/buttonBackground.svg';
import IncredibleIndiaLogo from '../../../../assets/img/carousel/incredible-india-logo.png';



const Background = styled.div`
    background-image: url(${CtaBg});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1rem;
    height: 40vh;
    position: relative;
    z-index: 100;
    margin-top: 2rem;

    @media (max-width: ${props => props.theme.pageWidth.s}px) {
        height: 65vh;
    }
`

const BackgroundOverlay = styled.div`
    width:100%;
    height:100%;
    position: absolute;
    background-color:black;
    opacity:.4;
`

const IncredibleIndia = styled.img`
    z-index:10;
    margin: 1.5rem auto 1rem auto;
    height: 2rem;
`;

const Title = styled.h2`
    z-index:10;
    margin: 0 auto .5rem auto;
    color: #FFF;
    text-align: center;
    font-size: 2.5em;
    font-family: ${props => props.theme.fonts.display};
    font-weight:400;
    text-transform: uppercase;
`;

const Subtitle = styled.p`
    z-index:10;
    color: #FFF;
    text-align: center;
    font-family: ${props => props.theme.fonts.text};
    margin: 0;
    margin-bottom: 2rem;
`;

const Button = styled.a`
    z-index:10;
    padding: 1.5rem 1rem;
    box-sizing: border-box;
    height: 4rem;
    width: 9.5rem;

    font-size: .85rem;
    font-weight: bold;
    font-family: ${props => props.theme.fonts.display};
    color: #FFF;
    vertical-align: middle;
    text-transform: uppercase;
    text-decoration: none;
    text-align: center;

    background: url(${ButtonBg});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    cursor: pointer;

    &::before, 
    &::after{
        content: " ";
        display: inline-block;
        width:5px;
        height:5px;
        margin: 2px 7px;
        border-radius: 50%;
        background-color: #FFF;
    }
`;

const ExternalCta = (props) => {
    return (
        <Background>
            <BackgroundOverlay></BackgroundOverlay>
            <IncredibleIndia src={IncredibleIndiaLogo} alt="Incredible India"/>
            <Title>Ancient history comes alive here</Title>
            <Subtitle>Discover the best of what incredible India has to offer</Subtitle>
            <Button href="https://www.incredibleindia.org/" target="_blank" rel="noopener sponsored">Explore</Button>
        </Background>
    );
};

export default withTheme(ExternalCta);